/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getOnboardingSuggestedStarterPacksSkeleton.defs.js'
export { main as default } from './getOnboardingSuggestedStarterPacksSkeleton.defs.js'
